export enum EnMenuItem {
  CHAPTERS = 'chapters',
  COMMENTS = 'comments',
  SETTINGS = 'settings',
  BOOKMARK = 'bookmark',
}
